import axios from 'axios'
import { BASE_URL } from '../../constants/config'

async function listNotifications(token, limit, skip) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            limit,
            skip
        },
        url: `${BASE_URL}/admin/notification`
    }
    return axios(options)
}

async function updateNotificationRead(token, notificationId) {
    const options = {
        method: 'put',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/notification/${notificationId}/read`
    }
    return axios(options)
}

async function notificationCount(token){
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/notification/count`
    }
    return axios(options)
}
export default {
    listNotifications,
    updateNotificationRead,
    notificationCount
}